var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5112 1.48876C13.3979 3.37541 13.4372 6.40986 11.6291 8.34433L11.5112 8.46629L6.61592 13.3616C5.15877 14.8187 2.79626 14.8187 1.33911 13.3616C-0.0806783 11.9418 -0.117083 9.66249 1.2299 8.19862L1.33911 8.08478L6.14248 3.28141C7.14269 2.2812 8.76434 2.2812 9.76454 3.28141C10.7325 4.24935 10.7637 5.79929 9.85822 6.80478L9.76454 6.90347L5.81153 10.8565C5.56021 11.1078 5.15274 11.1078 4.90142 10.8565C4.66943 10.6245 4.65158 10.2595 4.84788 10.007L4.90142 9.94637L8.85443 5.99336C9.352 5.4958 9.352 4.68909 8.85443 4.19152C8.38175 3.71884 7.63006 3.6952 7.12947 4.12062L7.05259 4.19152L2.24922 8.99489C1.29471 9.9494 1.29471 11.497 2.24922 12.4515C3.17192 13.3742 4.64879 13.4049 5.60843 12.5438L5.70581 12.4515L10.6011 7.55618C12.0253 6.13203 12.0253 3.82303 10.6011 2.39888C9.21348 1.01124 6.98579 0.975663 5.55507 2.29214L5.44381 2.39888L1.39887 6.44382C1.14754 6.69514 0.740073 6.69514 0.488753 6.44382C0.256764 6.21183 0.238919 5.84679 0.435217 5.59433L0.488753 5.53371L4.5337 1.48876C6.46049 -0.438027 9.58443 -0.438027 11.5112 1.48876Z",
    fill: "black",
    fillOpacity: 0.62
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/mediaIcon.f00650e461f66e88a7255512ff975042.svg";
export { ForwardRef as ReactComponent };